import { DEFAULT_LIMIT_PAGINATION } from 'constants/pagination';
import { assignmentsRepositories } from 'repositories/assignments';
import { TOptionsQuery } from 'types/common';
import { TTrainingDetail, TAnswerSubmit, TAnswerControlSubmit } from 'types/assignments';

const DEFAULT_ASSIGNMENTS_LIMIT = DEFAULT_LIMIT_PAGINATION;
const DEFAULT_ASSIGNMENTS_STUDENT_LIMIT = 20;
const DEFAULT_ASSIGNMENTS_PAGE = 1;

const getTrainings = async (params: TOptionsQuery<TTrainingDetail>) => {
  const res = await assignmentsRepositories.getTrainings({
    condition: {
      ...params,
      limit: params.limit ?? DEFAULT_ASSIGNMENTS_LIMIT,
      page: params.page ?? DEFAULT_ASSIGNMENTS_PAGE,
    },
  });

  if (res instanceof Error) {
    throw res;
  }

  return res.data;
};

const getTrainingsWorking = async (params: TOptionsQuery<TTrainingDetail>) => {
  const res = await assignmentsRepositories.getTrainings({
    condition: {
      ...params,
      limit: params.limit ?? DEFAULT_ASSIGNMENTS_STUDENT_LIMIT,
      page: params.page ?? DEFAULT_ASSIGNMENTS_PAGE,
    },
  });

  if (res instanceof Error) {
    throw res;
  }

  return res.data;
};

const getTrainingsFinish = async (params: TOptionsQuery<TTrainingDetail>) => {
  const res = await assignmentsRepositories.getTrainings({
    condition: {
      ...params,
      limit: params.limit ?? DEFAULT_ASSIGNMENTS_STUDENT_LIMIT,
      page: params.page ?? DEFAULT_ASSIGNMENTS_PAGE,
    },
  });

  if (res instanceof Error) {
    throw res;
  }

  return res.data;
};

const getTraining = async (data: { id: string; groupId: number }) => {
  const { id, groupId } = data;
  const res = await assignmentsRepositories.getTraining({
    pathParameters: {
      id,
    },
    condition: {
      groupId,
    },
  });

  if (res instanceof Error) {
    throw res;
  }

  return res.data;
};

const createTraining = async (t: TTrainingDetail & { groupId: number }) => {
  const { groupId, ...body } = t;

  const res = await assignmentsRepositories.createTraining({
    body,
    condition: {
      groupId,
    },
  });

  if (res instanceof Error) {
    throw res;
  }

  return res.data;
};

const updateTraining = async (t: TTrainingDetail & { groupId: number }) => {
  const { id, groupId, ...body } = t;
  const res = await assignmentsRepositories.updateTraining({
    body,
    pathParameters: {
      id,
    },
    condition: {
      groupId,
    },
  });

  if (res instanceof Error) {
    throw res;
  }

  return res.data;
};

const deleteTraining = async (data: { id: number; groupId: number }) => {
  const { id, groupId } = data;
  const res = await assignmentsRepositories.deleteTraining({
    pathParameters: {
      id,
    },
    condition: {
      groupId,
    },
  });

  if (res instanceof Error) {
    throw res;
  }

  return res.data;
};

const getDetailTaskForStudentDoes = async (id: string, groupId: number) => {
  const res = await assignmentsRepositories.getDetailTaskStudentDoes({
    pathParameters: {
      id,
    },
    condition: {
      groupId,
    },
  });
  if (res instanceof Error) {
    throw res;
  }

  return res.data;
};
const getResultsAssignment = async (data: { id: string; groupId: number }) => {
  const { id, groupId } = data;
  const res = await assignmentsRepositories.getResultsAssignment({
    pathParameters: {
      id,
    },
    condition: {
      groupId,
    },
  });

  if (res instanceof Error) {
    throw res;
  }

  return res.data;
};

const submitAnswerBasicTask = async (data: TAnswerSubmit) => {
  const res = await assignmentsRepositories.submitAnswerBasicTask({
    pathParameters: {
      id: data.id,
    },
    body: {
      basicAnswers: data.basicAnswers,
      eventAnswers: data.eventAnswers,
    },
  });

  if (res instanceof Error) {
    throw res;
  }

  return res.data;
};

const getResultsAssignmentOneStudent = async ({ id, sid }: { id: string; sid: string }) => {
  const res = await assignmentsRepositories.getResultAssignmentOneStudent({
    pathParameters: {
      id,
      sid,
    },
  });

  if (res instanceof Error) {
    throw res;
  }

  return res.data;
};

const updateCommentAssignment = async ({ id, sid, comment }: { id: number; sid: number; comment: string }) => {
  const res = await assignmentsRepositories.updateCommentAssignment({
    pathParameters: {
      id,
      sid,
    },
    body: {
      comment,
    },
  });

  if (res instanceof Error) {
    throw res;
  }

  return res.data;
};

const submitAnswerControlTask = async (data: TAnswerControlSubmit) => {
  const res = await assignmentsRepositories.submitAnswerControlTask({
    pathParameters: {
      id: data.id,
    },
    condition: {
      simulation: data.simulation,
    },
    body: {
      answers: data.answers,
    },
  });

  if (res instanceof Error) {
    throw res;
  }

  return res.data;
};
export const assignmentsServices = {
  getTrainings,
  getTraining,
  updateTraining,
  createTraining,
  deleteTraining,
  getTrainingsWorking,
  getTrainingsFinish,
  getDetailTaskForStudentDoes,
  getResultsAssignment,
  submitAnswerBasicTask,
  getResultsAssignmentOneStudent,
  updateCommentAssignment,
  submitAnswerControlTask,
};
